module.exports = __webpack_public_path__ + "static/img/61004.18b85ed0.png";